import React from 'react'
import Helmet from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import { useIntl } from 'react-intl'
import { HtmlTagSchemaMarkup } from './HtmlTagSchemaMarkup'

export function WebsiteJsonLd() {
    const intl = useIntl()
    const description = intl.formatMessage({ id: 'metas.home.description' })
    return (
        <>
            <Helmet
                script={[
                    helmetJsonLdProp({
                        '@context': 'https://schema.org',
                        '@type': 'WebSite',
                        name: 'Urban Linker',
                        url: window._app_url,
                        alternateName: description
                    }),
                ]}
            />
            <HtmlTagSchemaMarkup type="WebSite" />
        </>
    )
}
